import type { OpenAPIV3 } from 'openapi-types';

import React from 'react';

import useClassy from '@core/hooks/useClassy';
import { useProjectStore } from '@core/store';

import Button from '@ui/Button';
import Dropdown from '@ui/Dropdown';
import Flex from '@ui/Flex';
import Icon from '@ui/Icon';
import Menu, { MenuItem, MenuHeader } from '@ui/Menu';
import RDMD from '@ui/RDMD';

import classes from './style.module.scss';
import './style.scss';

const rdmdOpts = { copyButtons: false };

interface TagTooltipProps {
  inline?: boolean;
  pageId: string;
  tags: OpenAPIV3.TagObject[];
}

const TagTooltip = ({ inline = true, tags, pageId }: TagTooltipProps) => {
  const bem = useClassy(classes, 'TagTooltip');
  const isRmdx = useProjectStore(s => s.data.features.mdx === 'enabled');

  const TagContent = () => (
    <Menu>
      {tags.map(tag => (
        <div key={`${pageId}-${tag.name}-tag`} className={bem('-list')} data-testid="tag-content">
          <MenuHeader className={bem('-header')}>
            <Flex align="center" gap="size-4">
              <div>{tag.name}</div>
              <Icon aria-hidden="true" className={bem('-tag-icon')} name="tag" />
            </Flex>
          </MenuHeader>
          {!!tag.description && (
            <MenuItem
              description={
                <RDMD opts={rdmdOpts} renderer={isRmdx ? 'rmdx' : 'rdmd'}>
                  {tag.description}
                </RDMD>
              }
              focusable={false}
            />
          )}
          {!!tag.externalDocs && (
            <MenuItem color="blue" description={tag.externalDocs.url} href={tag.externalDocs.url} target="_blank">
              {tag.externalDocs.description}
            </MenuItem>
          )}
        </div>
      ))}
    </Menu>
  );

  return (
    <Dropdown key={`${pageId}-tagTooltip`} align="bottom" className={bem('rm-TagTooltip', '&')} justify="start" sticky>
      <Button
        aria-label="View tags"
        className={bem('-tag-button', inline && '-tag-button_inline')}
        kind="minimum"
        size="xs"
        text
      >
        <Icon aria-hidden="true" name="tag" size={14} />
      </Button>
      <TagContent />
    </Dropdown>
  );
};

export default TagTooltip;
